import * as enums from '~/const/enums'
import * as api from '~/myApi'
import RadioButtons from '~/component/form/RadioButtons'
import TargetRatios from '~/component/form/TargetRatios'
import { useFormikContext } from 'formik';

interface FormFieldProps {
  value?: api.TypesTargetRatio;
  targetCollectionNum?: number
}

export const Cluster: React.FC<FormFieldProps> = (props) => {
  const { setFieldValue } = useFormikContext();
  const cluster = enums.CLUSTER_TYPE.find(({ key }) => key === props.value?.clusterType)

  const onClusterTypeChange = (params: string) => {
    setFieldValue('targetRatio.clusterRatio', {
      isActive: true
    })
  }

  return (<>
    <RadioButtons {...{
      name: 'targetRatio.clusterType',
      value: props.value?.clusterType,
      items: enums.CLUSTER_TYPE,
      onChange: onClusterTypeChange
    }} />
    <TargetRatios {...{
      name: 'targetRatio.clusterRatio',
      value: props.value?.clusterRatio,
      items: cluster?.items || [],
      targetCollectionNum: props?.targetCollectionNum
    }} />
  </>
  )
}

export default Cluster